import { render, staticRenderFns } from "./RequestPart.vue?vue&type=template&id=2ba17e3f"
import script from "./RequestPart.vue?vue&type=script&lang=ts"
export * from "./RequestPart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports